import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=f22c7a6a&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "../../style/common-pc.scss?vue&type=style&index=0&id=f22c7a6a&prod&lang=scss&scoped=true&external"
import style1 from "./orderList.vue?vue&type=style&index=1&id=f22c7a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c7a6a",
  null
  
)

export default component.exports